import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchComponent } from '../../../base/search/search.component';
import { MessageService } from '../../../../services/messages/message.service';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { AppService } from '../../../../services/app.service';
import { GroupService } from '../../../../services/groups/group.service';
import { MessageSearchRequest } from '../../../../models/net/request/message-search-request';
import { MessageSearchResult } from '../../../../models/net/result/message-search-result';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { MessageEnvelope } from '../../../../models/net/envelope/message-envelope';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.css', '../../../../app.component.css']
})

export class MessagesComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["FromAvatarBlobPath", "From", "ToContacts", "CcContacts", "BccContacts", "Subject", "SentOnUTC", "CreatedOnUTC"];
    public override searchRequest: MessageSearchRequest = new MessageSearchRequest();
    public override searchResult: MessageSearchResult[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.MessageSearchRequest;
    public searchRequestTypeName: string = "MessageEnvelope";
    public searchRequestTileComponentTypeName: string = "MessageSearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: MessageService) {

        super(appService, sessionService, itemService, "message", "Message");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.MessageSearchRequest;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: MessageSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var searchRequest: MessageSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (searchRequest) {

                this.runSearch(searchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: MessageSearchResult) => i.MessageId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: MessageSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
